import AddRemoveBadBatch from "./AddRemoveBadBatch";
import { Fragment } from "react";
import Tests from "./Tests";
function ConfigPage() {
  return (
    <Fragment>
      <h1>Config</h1>
      <AddRemoveBadBatch />
      <h1>Tests</h1>
      <Tests />
    </Fragment>
  );
}

export default ConfigPage;
